export const ID_FACEBOOK = 'facebook' as const;
export const ID_TWITTER = 'twitter' as const;
export const ID_LINKEDIN = 'linkedin' as const;
export const ID_WHATSAPP = 'whatsapp' as const;
export const ID_EMAIL = 'email' as const;
export const ID_LINK = 'link' as const;
export const ID_SHARE = 'share' as const;
export const ID_COMMENTS = 'comments' as const;
export const ID_EDIT = 'edit' as const;
export const ID_DOWNLOAD = 'download' as const;
export const ID_FAVORITES = 'favorites' as const;

export const ENUMS_SOCIAL_NETWORKS = [ID_FACEBOOK, ID_TWITTER, ID_LINKEDIN, ID_WHATSAPP];

export const QUERY_DATE_TIME = 'd';
export const QUERY_PUBLISHER_ID = 'pi';
export const QUERY_WIDGET_ID = 'wi';
export const QUERY_DISTRIBUTION_ID = 'di';
export const QUERY_RETURN_URL = 'u';
